import { render, staticRenderFns } from "./CoachAdminLocaleSwitch.vue?vue&type=template&id=3fcee233"
import script from "./CoachAdminLocaleSwitch.vue?vue&type=script&lang=js"
export * from "./CoachAdminLocaleSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports